<template>
  <a-layout class="container">
    <!-- 左侧区域 -->
    <hina-base-slider
      :currentMenuKey="curMenuKey"
      :currentOpenKey="curOpenKey"
    />
    <!-- 主体区域 -->
    <a-layout>
      <!-- 头部 -->
      <hina-user-info :user="objUserInfo" />

      <a-layout-content>
        <!-- 位置 -->
        <hina-bread-crumb :link="arrBreadLink" />

        <div class="wrapper">
          <div class="wrap">
            <div class="hd">
              <div class="filter">
                <div class="title">职员管理</div>
                <div class="query">
                  <div class="query-item">
                    <a-dropdown-button>
                      查询方式
                      <a-menu
                        slot="overlay"
                        @click="handleMenuClick"
                        style="line-height: 48px"
                      >
                        <a-menu-item key="1">
                          <a-space
                            v-if="strQueryType == '姓名'"
                            style="color: #45a3ff"
                            >按姓名查询</a-space
                          >
                          <a-space v-else>按姓名查询</a-space>
                        </a-menu-item>
                        <a-menu-item key="2">
                          <a-space
                            v-if="strQueryType == '手机号'"
                            style="color: #45a3ff"
                            >按手机查询</a-space
                          >
                          <a-space v-else>按手机查询</a-space>
                        </a-menu-item>
                      </a-menu>
                      <a-icon slot="icon" type="user" />
                    </a-dropdown-button>
                  </div>
                  <div class="query-item">
                    <a-input
                      v-model="queryParams"
                      @keyup.enter="loadStaffList"
                      type="text"
                    />
                  </div>
                  <div class="query-item">
                    <a-button @click="loadStaffList" type="primary"
                      >查询</a-button
                    >
                  </div>
                  <div class="query-item">
                    <a-button type="primary" @click="handlerInviteModel"
                      >邀请职员加入</a-button
                    >
                  </div>
                  <div class="query-item">
                    <a-button type="primary" @click="handlerNewModel"
                      >新增职员</a-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="trans-table">
              <a-table

                :columns="columns"
                :data-source="data"
                :pagination="pagination"
                :loading="loading"
                @change="handleTableChange"
              >
                <template slot="action" slot-scope="text, record">
                  <a href="javascript:;" @click="handlerDeleteStaff(record)"
                    >删除</a
                  >
                  <a-divider type="vertical" />
                  <a href="javascript:;" @click="handlerUpdateModel(record)"
                    >修改</a
                  >
                  <a-divider type="vertical" />
                  <a href="javascript:;" @click="handlerAllocationModal(record)"
                  >分配额度</a
                  >
                  <a-divider type="vertical" />
                  <a href="javascript:;" @click="handlerInviteDetailsModel(record)"
                  >邀请明细</a
                  >
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </a-layout-content>

      <a-modal
        v-model="isInsertStaff"
        title="新增职员"
        :width="760"
        :centered="true"
        :cancelButtonProps="{ style: { display: 'none' } }"
        okText="保存职员"
        cancelText="取消"
        @ok="handlerSaveStaff"
        ref="frmNewStaff"
        :model="frmNewStaff"
      >
        <div class="frm-staff">
          <a-row class="frm-line" :gutter="10">
            <a-col :span="6" class="lab required">职员手机号</a-col>
            <a-col :span="8" class="txt">
              <a-input
                v-model="frmNewStaff.phone"
                type="text"
                autocomplete="off"
              />
              <a-alert v-if="isPhone" :message="resultMessage" :type="color" />
            </a-col>
            <a-col :span="10">
            </a-col>
          </a-row>
          <a-row class="frm-line" :gutter="10">
            <a-col :span="6" class="lab required">职员姓名</a-col>
            <a-col :span="18" class="txt">
              <a-input
                v-model="frmNewStaff.userName"
                type="text"
                :disabled="isExistAccount"
              />
            </a-col>
          </a-row>
          <a-row class="frm-line" :gutter="10">
            <a-col :span="6" class="lab required">分配额度</a-col>
            <a-col :span="6" class="txt">
              <a-input
                v-model="frmNewStaff.balance"
                type="text"
                prefix="￥"
                :disabled="isExistAccount"
              />
            </a-col>
          </a-row>
          <a-row class="frm-line" :gutter="10">
            <a-col :span="6" class="lab required">单笔可用比例</a-col>
            <a-col :span="6" class="txt">
              <a-input
                v-model="frmNewStaff.usageRatio"
                type="text"
                suffix="%"
                :disabled="isExistAccount"
              />
            </a-col>
          </a-row>
          <a-row class="frm-line" :gutter="10">
            <a-col :span="6" class="lab required">身份证号</a-col>
            <a-col :span="18" class="txt">
              <a-input
                v-model="frmNewStaff.number"
                type="text"
                :disabled="false"
              />
            </a-col>
          </a-row>
        </div>
      </a-modal>

      <a-modal
        v-model="isUpdateStaff"
        title="修改职员"
        :width="760"
        :centered="true"
        :cancelButtonProps="{ style: { display: 'none' } }"
        okText="修改职员"
        cancelText="取消"
        @ok="handlerUpdateStaff"
        ref="frmNewStaff"
        :model="frmNewStaff"
      >
        <div class="frm-staff">
          <a-row class="frm-line" :gutter="10">
            <a-col :span="6" class="lab required">职员账号</a-col>
            <a-col :span="8" class="txt">
              <a-input
                v-model="frmNewStaff.phone"
                type="text"
                autocomplete="off"
                :disabled="true"
              />
            </a-col>
          </a-row>
          <a-row class="frm-line" :gutter="10">
            <a-col :span="6" class="lab required">职员姓名</a-col>
            <a-col :span="18" class="txt">
              <a-input
                v-model="frmNewStaff.userName"
                type="text"
                :disabled="true"
              />
            </a-col>
          </a-row>
          <a-row class="frm-line" :gutter="10">
            <a-col :span="6" class="lab required">单笔可用比例</a-col>
            <a-col :span="6" class="txt">
              <a-input
                v-model="frmNewStaff.usageRatio"
                type="text"
                suffix="%"
              />
            </a-col>
          </a-row>
          <a-row class="frm-line" :gutter="10">
            <a-col :span="6" class="lab required">身份证号</a-col>
            <a-col :span="18" class="txt">
              <a-input
                v-model="frmNewStaff.number"
                type="text"
                :disabled="isExistAccount"
              />
            </a-col>
          </a-row>
        </div>
      </a-modal>


      <a-modal
          v-model="isAllocationStaff"
          title="分配额度"
          :width="760"
          :centered="true"
          :cancelButtonProps="{ style: { display: 'none' } }"
          okText="分配额度"
          cancelText="取消"
          @ok="handlerAllocationStaff"
          :confirmLoading="loading"
          ref="frmNewStaff"
          :model="frmNewStaff"
      >
        <div class="frm-staff">
          <a-row class="frm-line" :gutter="10">
            <a-col :span="4" class="lab required">分配额度</a-col>
            <a-col :span="12" class="txt">
              <a-input
                  v-model="frmAllocation.balance"
                  type="number"
                  placeholder="正数为增加，负数为扣减"
                  autocomplete="off"
              />
            </a-col>
          </a-row>
        </div>
      </a-modal>
      <!-- 邀请弹框 -->
      <a-modal
        v-model="inviteModal"
        :width="500"
        :centered="true"
        :okButtonProps="{ style: { display: 'none' } }"
        cancelText="取消"
      >
      <template v-slot:title>
          <span>邀请职员扫码加入</span>
          <span style="color: red">（ 请使用微信扫码 ）</span>
      </template>
        <div class="frm-staff">
          <a-row class="frm-line" :gutter="10">
            <vue-qr
                :logoSrc="qrCode.logoSrc"
                :text="qrCodeText"
                :callback="qrCodeCallback"
                :size="260"
                :correctLevel="1"
                :margin="10"
              ></vue-qr>
              <div style="margin-top: 20rpx;">员工邀请成功次数：<span style="color: red;">{{ joinCount }}</span>次</div>
          </a-row>
        </div>
      </a-modal>
      <!-- 邀请明细弹框 -->
      <a-modal
        v-model="inviteDetailsModal"
        title="邀请明细"
        :width="760"
        :centered="true"
        :okButtonProps="{ style: { display: 'none' } }"
        cancelText="取消"
      >
      <!-- <div class="query" style="display: flex; align-items: center; margin-bottom: 20px">
        <div class="query-item">
          <a-dropdown-button>
            查询方式
            <a-menu
              slot="overlay"
              @click="handleMenuClick"
              style="line-height: 48px"
            >
              <a-menu-item key="2">
                <a-space
                  v-if="strQueryType == '昵称'"
                  style="color: #45a3ff"
                  >按昵称查询</a-space
                >
                <a-space v-else>按昵称查询</a-space>
              </a-menu-item>
              <a-menu-item key="2">
                <a-space
                  v-if="strQueryType == '手机号'"
                  style="color: #45a3ff"
                  >按手机查询</a-space
                >
                <a-space v-else>按手机查询</a-space>
              </a-menu-item>
            </a-menu>
            <a-icon slot="icon" type="user" />
          </a-dropdown-button>
        </div>
        <div class="query-item" style="margin: 0 10px;">
          <a-input
            v-model="pagination.keywords"
            @keyup.enter="getInviteList"
            type="text"
          />
        </div>
        <div class="query-item">
          <a-button @click="getInviteList" type="primary"
            >查询</a-button
          >
        </div>
      </div> -->
        <!-- <a-range-picker
          style="margin-bottom: 24px;"
          :show-time="{ format: 'HH:mm' }"
          format="YYYY-MM-DD HH:mm"
          :placeholder="['开始时间', '结束时间']"
          :locale="locale"
          @change="onDateTimeChange"
          @ok="onDateTimeOk"
        >
          <a-icon slot="suffixIcon" type="calendar" />
        </a-range-picker> -->
            <a-table
              bordered
              :columns="inviteColumns"
              :data-source="inviteData"
              :row-key="(record) => record.id"
              :pagination="paginationInvite"
              @change="handleInviteTableChange"
            >
              </a-table>
      </a-modal>
    </a-layout>
  </a-layout>
</template>

<script>
import HinaBaseSlider from "components/HinaBaseSlider/HinaBaseSlider";
import HinaUserInfo from "components/HinaUserInfo/HinaUserInfo";
import HinaBreadCrumb from "components/HinaBreadCrumb/HinaBreadCrumb";
import utils from "assets/js/util";
import vueQr from "vue-qr";
import locale from "ant-design-vue/lib/date-picker/locale/zh_CN";

const columns = [
  {
    title: "手机号",
    dataIndex: "phone",
  },
  {
    title: "用户名称",
    dataIndex: "userName",
  },
  {
    title: "身份证号",
    dataIndex: "number",
  },
  {
    title: "使用比例",
    dataIndex: "usageRatio",
  },
  {
    title: "剩余额度",
    dataIndex: "surplusBalance",
  },
  {
    title: "客户池人数",
    dataIndex: "inviteCount",
  },
  {
    title: "累计收益",
    dataIndex: "inviteMoney",
  },
  {
    title: "是否关联",
    dataIndex: "flag",
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

export default {
  name: "Profile",
  components: {
    HinaBaseSlider,
    HinaUserInfo,
    HinaBreadCrumb,
    vueQr
  },
  data() {
    return {
      locale,
      frmAllocation:{},
      isAllocationStaff:false,//打开分配额度弹窗
      objUserInfo: {},
      curMenuKey: ["staff"],
      curOpenKey: ["sub1"],
      arrBreadLink: [],
      isInsertStaff: false, // 打开新增额度配置弹窗
      isUpdateStaff: false, // 打开修改额度配置弹窗
      inviteModal:false,// 邀请弹框
      isExistAccount: false, // 验证账号
      isExistUpdate: true, // 是否修改账号
      isPhone: false,
      resultMessage: "",
      color: "error",
      pagination: {},
      loading: false,
      frmNewStaff: {
        userName: "", // 姓名
        phone: "", // 手机号
        usageRatio: null, // 单笔可用比例
        balance: null, // 最新额度
        enterpriseId: 0, // 企业id
        number: "", // 身份证号
        enterpriseFullName: "", // 企业全称
      },

      strQueryType: "姓名",

      queryParams: "",

      data: [],
      columns,
      qrCode: {
        logoSrc: "http://fxinpz.com/images/fxpeizhen/system/202210/fc4297f3c53b43fca2575ecc9fb4b6a8.jpg", // 嵌入二维码中心的logo图片地址。
      },
      qrCodeUrl: '', // 存放生成的二维码url
      joinCount:0,// 邀请员工人数
      inviteDetailsModal:false,//邀请明细弹框
      inviteColumns: [
        {
          title: "被邀请人昵称",
          dataIndex: "name",
        },{
          title: "手机号",
          dataIndex: "phone",
        },{
          title: "收益",
          dataIndex: "money",
        },{
          title: "邀请时间",
          dataIndex: "inviterTime",
        },],
      inviteData: [],
      pagination: {
        pageSize: 10,
        total: 0,
        current: 1,
      },
      paginationInvite: {
        pageSize: 5,
        total: 0,
        current: 1,
        // startDate:'',
        // endDate:'',
        keywords:''
      },
    };
  },
  computed: {
    qrCodeText() {
      return `https://fxinpz.com/wechat/joinEnterprise?enterpriseId=${this.objUserInfo.id}&enterpriseName=${this.objUserInfo.name}`;
      // return `https://fxinpz.com/wechat/joinEnterprise?enterpriseId=1656567583526309890&enterpriseName=北京天天科技有限公司`; // 二维码的内容，即扫出来的结果。
    },
  },
  methods: {
    qrCodeCallback(url){
      this.qrCodeUrl = url
    },
    // 获取通过邀请进入企业人员数量
    loadJoinUserCount(){
      this.$get("/enterpriseUser/joinUserCount", {}).then((res) => {
        if(res.success){
            this.joinCount=res.result
          }
      })
    },
    //查询职员列表
    loadStaffList() {
      //查询对象
      let params = {
        enterpriseId: this.objUserInfo.id,
        phone: null,
        userName: null,
        pageNumber: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };
      if (this.strQueryType === "手机号") {
        params.phone = this.queryParams;
      } else if (this.strQueryType === "姓名") {
        params.userName = this.queryParams;
      }
      this.data = [];
      this.$get("enterpriseUser/list", params).then((res) => {
        let records = res.result.records;
        for (let i = 0; i < records.length; i++) {
          this.data.push({
            key: i,
            id: records[i].id,
            phone: records[i].phone,
            number: records[i].number,
            userName: records[i].userName,
            usageRatio: records[i].usageRatio,
            balance: records[i].balance,
            surplusBalance: records[i].balance,
            inviteCount:records[i].inviteCount,
            inviteMoney: records[i].inviteMoney,
            flag: records[i].flag == 1 ? "关联" : "未关联",
            userId:records[i].userId,
          });
        }
        this.pagination = {
          current: res.result.current,
          pageSize: res.result.size,
          total: res.result.total,
        };
        this.loading = false;
      });
    },

    handleMenuClick: function (e) {
      if (e.key == 1) {
        this.strQueryType = "姓名";
      } if (e.key == 2) {
        this.strQueryType = "昵称";
      } else {
        this.strQueryType = "手机号";
      }
    },
    // 邀请弹框
    handlerInviteModel(){
      this.inviteModal=true
      this.loadJoinUserCount()

    },
    // 操作额度配置弹窗
    handlerNewModel: function () {
      this.isInsertStaff = !this.isInsertStaff;
      this.isPhone = false;
      this.resultMessage = "";
      this.frmNewStaff = {
        userName: "", // 姓名
        phone: "", // 手机号
        usageRatio: null, // 单笔可用比例
        balance: null, // 最新额度
        enterpriseId: this.$store.state.userInfo.id, // 企业id
        number: "", // 身份证号
        enterpriseFullName: this.$store.state.userInfo.enterpriseFullName, // 企业全称
      };
      this.isExistAccount = false;
    },

    // 保存新增职员
    handlerSaveStaff: function () {
      if (this.isExistAccount) {
        this.$message.error("请先验证账号");
        return;
      }
      if (this.frmNewStaff.userName == "") {
        this.$message.error("请输入姓名");
        return;
      }
      // if (!utils.isName(this.frmNewStaff.userName)) {
      //   this.$message.error("姓名请输入汉字");
      // }
      if (this.frmNewStaff.phone == "") {
        this.$message.error("请输入手机号");
        return;
      }
      //手机号验证
      if (!utils.isMobile(this.frmNewStaff.phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      if (this.frmNewStaff.balance == "") {
        this.$message.error("请输入分配额度");
        return;
      }
      if (!utils.isNum(this.frmNewStaff.balance)) {
        this.$message.error("请输入正确的分配额度");
        return;
      }
      if (!this.frmNewStaff.usageRatio) {
        this.$message.error("请输入单笔可用比例");
        return;
      }
      if (!utils.isNum100(this.frmNewStaff.usageRatio)) {
        this.$message.error("请输入正确的单笔可用比例");
        return;
      }
      if (this.frmNewStaff.number == "") {
        this.$message.error("请输入身份证号");
        return;
      }
      if (!utils.isCardNo(this.frmNewStaff.number)) {
        this.$message.error("请输入正确的身份证号");
        return;
      }
      // 调用接口保存
      this.$post("enterpriseUser/save", this.frmNewStaff, true).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("保存成功");
          this.loadStaffList();
          // 关闭弹窗
          this.handlerNewModel();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handlerAllocationModal:function (record){
      this.isAllocationStaff=!this.isAllocationStaff;
      this.frmAllocation.userId=record.userId;
      this.frmAllocation.id=record.id;
      console.log(this.frmAllocation)
    },
    // 邀请明细弹框
    handlerInviteDetailsModel(record){
      this.inviteDetailsModal=true
      this.userId=record.userId
      this.getInviteList();
    },
    handleInviteTableChange(pagination, filters, sorter, currentDataSource) {
      this.paginationInvite.current  = pagination.current;
      this.getInviteList();
    },
    onDateTimeChange: function (value, dateString) {
      console.log("Selected Time: ", value);
      console.log("Formatted Selected Time: ", dateString);
      this.paginationInvite.startDate = dateString[0];
      this.paginationInvite.endDate = dateString[1];
    },
    onDateTimeOk: function (value) {
      console.log("onDateTimeOk: ", value);
      this.getInviteList()
    },
    // 邀请明细列表
    getInviteList(){
      // this.inviteData = [];
      let params = {
        pageNumber: this.paginationInvite.current,
        pageSize: this.paginationInvite.pageSize,
        startDate:this.paginationInvite.startDate,
        endDate:this.paginationInvite.endDate,
        keywords: this.paginationInvite.keywords
      };
      this.$get(`/enterpriseUser/staffInviteUserInfo/${this.userId}`, params).then((res) => {
        this.inviteData = res.result.records;
        this.paginationInvite = {
          current: res.result.current,
          pageSize: res.result.size,
          total: res.result.total,
        };
      });
    },
    handlerUpdateModel: function (record) {
      this.isUpdateStaff = !this.isUpdateStaff;
      if (this.isUpdateStaff) {
        this.$get("enterpriseUser/detail/" + record.id).then((res) => {
          this.frmNewStaff = res.result;
          this.frmNewStaff.balance = 0;
        });
      } else {
        this.frmNewStaff = {
          userName: "", // 姓名
          phone: "", // 手机号
          usageRatio: null, // 单笔可用比例
          balance: null, // 最新额度
          enterpriseId: this.$store.state.userInfo.id, // 企业id
          number: "", // 身份证号
          enterpriseFullName: this.$store.state.userInfo.enterpriseFullName, // 企业全称
        };
      }
    },

    handlerAllocationStaff:function (){
      if (isNaN(this.frmAllocation.balance)||this.frmAllocation.balance==0){
        this.$message.error("信息不完整，请检查额度是否正确。")
        return;
      }
      if (!(this.frmAllocation.userId)){
        this.$message.error("分配失败，请重新打开分配窗口后尝试。")
        return;
      }
      this.loading=true;
      this.$put("enterpriseUser/enterpriseRecharge", this.frmAllocation, true).then((res) => {
        this.loading=false;
        if (res.data.code == 200) {
          this.$message.success("分配成功")
          this.loadStaffList();
          // 关闭弹窗
          this.handlerAllocationModal({userId:0});
        } else {
          this.$message.error(res.data.message);
        }
      });

    },

    // 保存修改职员
    handlerUpdateStaff: function () {
      if (!utils.isNum(this.frmNewStaff.balance)) {
        this.$message.error("请输入正确的分配额度");
        return;
      }
      if (!this.frmNewStaff.usageRatio) {
        this.$message.error("请输入单笔可用比例");
        return;
      }
      if (!utils.isNum100(this.frmNewStaff.usageRatio)) {
        this.$message.error("请输入正确的单笔可用比例");
        return;
      }
      if (!this.frmNewStaff.number) {
        this.$message.error("请输入身份证号");
        return;
      }
      if (!utils.isCardNo(this.frmNewStaff.number)) {
        this.$message.error("请输入正确的身份证号");
        return;
      }
      // 调用接口保存
      this.$put("enterpriseUser/update", this.frmNewStaff, true).then((res) => {
        this.$message.success("保存成功");
        this.loadStaffList();
        // 关闭弹窗
        this.handlerUpdateModel();
      }).catch(err => {
        this.$message.error(err.response.data.message);
      })
    },

    //删除职员
    handlerDeleteStaff: function (row) {
      let _this = this;
      this.$confirm({
        title: "确定删除该职员吗？",
        content: "删除后该职员将离开企业,无法再使用企业的额度",
        okText: "确定",
        okType: "danger",
        cancelText: "取消",
        onOk() {
          _this.$get("enterpriseUser/remove/" + row.id).then((res) => {
            if (res.success) {
              _this.$message.success("删除成功");
              _this.loadStaffList();
            } else {
              _this.$message.error(res.message);
            }
          });
        },
        onCancel() {},
      });
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.loading = true;
      this.loadStaffList();
    },

    // 验证账号是否存在
    handlerCheckAccount: function () {
      if (this.frmNewStaff.phone == "") {
        this.$message.error("请输入手机号");
        return;
      }
      //验证手机号格式
      if (!utils.isMobile(this.frmNewStaff.phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      // 调用接口
      this.$get("enterpriseUser/isExist", {
        phone: this.frmNewStaff.phone,
      }).then((res) => {
        this.isExistAccount = res.result;
        this.isPhone = true;
        this.resultMessage = res.message;
        this.color = res.message === "验证通过" ? "success" : "error";
      });
    },
  },
  mounted: function () {
    this.objUserInfo = {
      id: this.$store.state.userInfo.id,
      name: this.$store.state.userInfo.enterpriseFullName,
    };
    this.frmNewStaff.enterpriseId = this.$store.state.userInfo.id;
    this.frmNewStaff.enterpriseFullName =
      this.$store.state.userInfo.enterpriseFullName;
    this.arrBreadLink.push({ name: "企业信息", link: "/profile" });
    this.loadStaffList();
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .wrap {
    margin: 20px 0 0;
    padding: 0 24px;
    background: #fff;
    min-height: 240px;

    .hd {
      height: 72px;
      line-height: 72px;
      color: #333;
      font-weight: 600;
      font-size: 18px;
      position: relative;
      margin-bottom: 30px;

      &::after {
        position: absolute;
        content: "";
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
        left: 0;
        right: 0;
        bottom: 0;
      }

      .filter {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .query {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .query-item {
            padding: 0 0 0 5px;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }

    .trans-table {
      padding: 0 0 5px;
    }
  }

  .wrap:first-of-type {
    margin: 0;
  }
}

.frm-staff {
  padding: 20px 50px;
  text-align: center;

  .frm-line {
    min-height: 72px;
    padding: 12px 0;
    box-sizing: border-box;

    .lab {
      font-size: 16px;
      line-height: 48px;
      text-align: right;
      position: relative;

      &::after {
        position: relative;
        content: "：";
      }
    }

    .required {
      &::before {
        position: relative;
        content: "*";
        color: red;
        padding: 0 5px 0 0;
      }
    }

    .txt {
      line-height: 48px;
      font-size: 16px;
    }
  }
}
</style>
